import { Problem, ProblemDetectionContext, ProblemType, ProblemSeverity } from '../types';

export function detectLambdaInvocationIssues(context: ProblemDetectionContext, generateId: () => string): Problem[] {
  const problems: Problem[] = [];
  const { logs } = context;

  const lambdaErrorLogs = logs.filter(
    (log) =>
      log.LogData.Action?.Type === 'InvokeLambdaFunction' &&
      (log.LogData.Action?.ExecutionResult === 'Error' || log.LogData.Action?.ExecutionResult === 'Failed')
  );

  lambdaErrorLogs.forEach((errorLog) => {
    const originalIndex = logs.indexOf(errorLog);
    problems.push({
      id: generateId(),
      type: ProblemType.LAMBDA_INVOCATION_ISSUES,
      severity: ProblemSeverity.HIGH,
      title: 'Lambda Function Invocation Failed',
      description: `Lambda function "${errorLog.LogData.Action?.Parameters?.FunctionArn || 'Unknown'}" failed to execute`,
      timestamp: errorLog.AbsoluteTime,
      source: 'IVR_LOG',
      relatedData: { log: errorLog },
      suggestions: [
        'Check Lambda function logs for detailed error information',
        'Verify Lambda function permissions and configuration',
        'Review function timeout and memory settings'
      ],
      index: originalIndex >= 0 ? originalIndex : undefined
    });
  });

  return problems;
}
